import { render, staticRenderFns } from "./EcPagination.vue?vue&type=template&id=6be3b235"
import script from "./EcPagination.vue?vue&type=script&lang=js"
export * from "./EcPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports